function updateHeaderCartCount(count) {
  const countElement = document.getElementById('cart-count')
  if (count === 0) {
    countElement.hidden = true
  } else {
    countElement.textContent = count
    countElement.hidden = false
  }
}

//this is required to deal with the scenario where a user increments/decrements the quantity quickly
function debounce(func, timeout = 500) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

function openCartDrawer() {
  document.getElementsByTagName('html')[0].classList.add('cart-open')
}

function customInputNumberListeners(form) {
  const formAction = form.getAttribute('action')
  const minimumValue = formAction === '/cart' ? 0 : 1
  form.querySelectorAll('.input-number-wrapper button').forEach((button) => {
    button.addEventListener('click', async () => {
      const inputElement = button.parentElement.querySelector('input')
      let currentQuantity = Number(inputElement.value)
      const increment = button.classList.contains('plus')
      //this increments and decrements (with a minimum value of 0)
      const newQuantity = increment
        ? currentQuantity + 1
        : currentQuantity > minimumValue
        ? currentQuantity - 1
        : minimumValue

      inputElement.value = newQuantity //set value in ui immediately
      inputElement.dispatchEvent(new Event('change', { bubbles: true }))
    })
  })
}

function handleAddToCartFormEvents(addToCartForm) {
  customInputNumberListeners(addToCartForm)

  addToCartForm.addEventListener('submit', async (event) => {
    //prevent normal submission
    event.preventDefault()

    //submit form with ajax
    await fetch('/cart/add.js', {
      method: 'post',
      body: new FormData(addToCartForm)
    })

    await updateCartDrawer()
    await new Promise((x) => setTimeout(x, 100)) //this is used to ensure the open-cart transition works. without it the transition is skipped
    openCartDrawer()

    //Get new cart object
    const res = await fetch('/cart.json')
    const cart = await res.json()

    updateHeaderCartCount(cart.item_count)
  })
}

;(() => {
  document
    .getElementById('open-cart-drawer')
    .addEventListener('click', function () {
      openCartDrawer()
    })

  const addToCartFormSelector = 'form[action="/cart/add"]'
  //handle add to cart forms already on the page at load time
  document
    .querySelectorAll(addToCartFormSelector)
    .forEach((form) => handleAddToCartFormEvents(form))

  const addToCartFormObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches(addToCartFormSelector)
        ) {
          handleAddToCartFormEvents(node)
        }
        //also check child nodes
        node
          .querySelectorAll?.(addToCartFormSelector)
          .forEach((child) => handleAddToCartFormEvents(child))
      })
    })
  })

  //handle add to cart forms loaded dynamically e.g. quick view products
  addToCartFormObserver.observe(document.body, {
    childList: true,
    subtree: true
  })
})()
